<template>
  <div>
    <h1>Schedule</h1>
    <div class="row">
      <div class="col-md-4">
        <b-form-group label="Date" label-for="date">
          <b-form-select id="date" v-model="selectedDay" :options="days" class="mb-3" />
        </b-form-group>
      </div>
      <div class="col-md-4">
        <b-form-group label="Venue" label-for="venue">
          <b-form-select id="venue" v-model="selectedVenue" :options="venueSelect" class="mb-3" />
        </b-form-group>
      </div>
    </div>

    <!-- <h2 v-if="selectedDay === '2023-08-04'">Friday 04 Aug 2023</h2> -->
    <h2 v-if="selectedDay === '2023-08-05'">Saturday 05 Aug 2023</h2>
    <h2 v-if="selectedDay === '2023-08-06'">Sunday 06 Aug 2023</h2>
    <h2 v-if="selectedDay === '2023-08-07'">Monday 07 Aug 2023</h2>
    <h2 v-if="selectedDay === '2023-08-08'">Tuesday 08 Aug 2023</h2>
    <h2 v-if="selectedDay === '2023-08-09'">Wednesday 09 Aug 2023</h2>
    <h2 v-if="selectedDay === '2023-08-10'">Thursday 10 Aug 2023</h2>
    <div v-if="isLoaded">
      <!-- <h3 v-if="dayVenues.length === 0 && selectedDay === '2023-08-04'">No shifts for Friday 04 Aug 2023</h3> -->
      <h3 v-if="dayVenues.length === 0 && selectedDay === '2023-08-05'">No shifts for Saturday 05 Aug 2023</h3>
      <h3 v-if="dayVenues.length === 0 && selectedDay === '2023-08-06'">No shifts for Sunday 06 Aug 2023</h3>
      <h3 v-if="dayVenues.length === 0 && selectedDay === '2023-08-07'">No shifts for Monday 07 Aug 2023</h3>
      <h3 v-if="dayVenues.length === 0 && selectedDay === '2023-08-08'">No shifts for Tuesday 08 Aug 2023</h3>
      <h3 v-if="dayVenues.length === 0 && selectedDay === '2023-08-09'">No shifts for Wednesday 09 Aug 2023</h3>
      <h3 v-if="dayVenues.length === 0 && selectedDay === '2023-08-10'">No shifts for Thursday 10 Aug 2023</h3>

      <div class="cd-schedule">
        <!-- <div class="timeline">
        <ul>
          <li v-for="time in startTimes">
            <span>{{ time.text }}</span>
          </li>
        </ul>
      </div> -->
        <div class="events">

          <ul>
            <li v-for="venue in dayVenues" :style="getVenueWidth(dayVenues.length)" :key="venue.id" class="events-group">
              <div class="top-info">
                <span>
                  {{ venue.name }}
                  <!-- <br>
                {{ venue.location }} -->
                </span>
              </div>
              <ul>
                <li v-for="shift in venue.shifts" :style="getLocation(shift)" :key="shift.id" class="single-event">
                  <a @click.prevent="goToShift(shift.id)" :href="'/schedule/shift/' + shift.id">
                    <span class="event-day">{{ formattedDay(shift.day) }}</span>
                    <em class="event-time">{{ shift.start_time }} - {{ shift.end_time }}</em>
                    <p class="event-location">{{ shift.venue.location }}</p>
                    <em class="event-notes">{{ shift.special }}</em>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div v-else>
      <h2>Loading Shifts...</h2>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { TLdays, startTimes } from '@/util/SelectLists'
import moment from 'moment-timezone'
import router from '@/router'

export default {
  name: 'TlSchedule',
  data () {
    return {
      selectedDay: '2024-07-26',
      selectedVenue: 'all',
      days: TLdays,
      startTimes: startTimes,
      selectedShift: {
        start_time: '00:00',
        end_time: '01:00',
        swappable: false,
        day: '2024-07-26',
        sv_slots: 1,
        special: '',
        venue: {
          name: '',
          location: '',
          teamLeaders: []
        }
      }
    }
  },
  methods: {
    formattedDay: function (day) {
      return moment(day).utc().format('ddd MMM Do')
    },
    selectShift: function (shift) {
      this.selectedShift = shift
      this.$refs.shiftModal.show()
    },
    goToShift: function (id) {
      router.push('/schedule/shift/' + id)
    },
    closeModal: function () {
      this.selectedShift = {
        start_time: '00:00',
        end_time: '01:00',
        swappable: false,
        day: '2024-07-26',
        sv_slots: 1,
        special: '',
        venue: {
          name: '',
          location: '',
          teamLeaders: []
        }
      }
      this.$refs.shiftModal.hide()
    },
    getVenueWidth: function (venues) {
      let width = 100
      // if (this.$mq !== 'mobile') {
      //   width = 100 / venues
      // }
      return 'width: ' + width + '%;'
    },
    getLocation: function (shift) {
      // let start = this.getTimestamp(shift.start_time)
      // let duration = this.getTimestamp(shift.end_time) - start
      // let top = 50 * (start - this.getTimestamp(this.startTimes[0].value)) / 1800
      // let height = 50 * duration / 1800
      if (this.$mq !== 'mobile') {
        // return 'top: ' + top + 'px; height: ' + height + 'px;'
        return 'top: ' + top + 'px; height: 100px; margin-top: 5px; margin-bottom: 5px;'
      } else {
        // return 'top: ' + top + 'px; height: 100px;'
        return 'top: ' + top + 'px; height: 190px;'
      }
    },
    getTimelineHeight: function () {
      // if (this.$mq === 'mobile') {
      return 'height: 100%;'
      // }
      // let sections = (this.startTimes.length * 50)
      // return 'height: ' + sections + 'px;'
    },
    getTimestamp: function (time) {
      let timeArray = time.split(':')
      return parseInt((timeArray[0] * 60 * 60) + parseInt(timeArray[1]) * 60)
    }
  },
  computed: {
    ...mapState('schedule', ['shifts', 'isLoaded']),
    ...mapGetters('schedule', ['nextShift']),
    ...mapGetters(['isError', 'isMessage']),
    dayShifts: function () {
      return this.shifts.filter(shift => {
        return this.selectedDay === moment(shift.day).utc().format('Y-MM-DD')
      })
    },
    venueSelect: function () {
      let venueSelect = [{ value: 'all', text: 'Show All' }]
      this.shifts.forEach(s => {
        let existingVenue = venueSelect.findIndex(v => {
          return v.value === s.venue.name || (s.venue.name.includes('History') && v.value === 'History')
        })
        if (existingVenue === -1) {
          if (s.venue.name.includes('History')) {
            venueSelect.push({
              value: 'History',
              text: 'History'
            })
          } else {
            venueSelect.push({
              value: s.venue.name,
              // text: s.venue.name + ' - ' + s.venue.location
              text: s.venue.name
            })
          }
        }
      })
      return venueSelect
    },
    dayVenues: function () {
      let venues = []
      this.shifts.forEach(s => {
        let existingVenue = venues.findIndex(v => {
          return v.name === s.venue.name || (s.venue.name.includes('History') && v.name === 'History')
        })
        if (existingVenue !== -1) {
          if (this.selectedDay === moment(s.day).utc().format('Y-MM-DD')) {
            if (s.venue.name.includes('History')) {
              let split = s.venue.name.split(', ')
              if (split.length > 1) {
                s.venue.location = split[1] + ': ' + s.venue.location
              }
            }
            venues[existingVenue].shifts.push(s)
          }
        } else {
          let venue = s.venue
          venue.shifts = []
          if (this.selectedDay === moment(s.day).utc().format('Y-MM-DD')) {
            if (s.venue.name.includes('History')) {
              venue.name = 'History'
              let split = s.venue.name.split(', ')
              if (split.length > 1) {
                s.venue.location = split[1] + ': ' + s.venue.location
              }
            }
            venue.shifts.push(s)
            venues.push(venue)
          }
        }
      })
      if (this.selectedVenue !== 'all') {
        return venues.filter(v => {
          return v.name === this.selectedVenue
        })
      } else {
        return venues
      }
    }
  },
  created () {
    if (!this.$store.state.schedule.isLoaded) {
      this.$store.dispatch('schedule/load')
    }
    if (moment(this.selectedDay).isBefore(moment(), 'day')) {
      if (moment().isAfter(moment(this.days[this.days.length - 1].value))) {
        this.selectedDay = this.days[this.days.length - 1].value
      } else {
        this.selectedDay = moment().format('Y-MM-DD')
      }
    }
  }
}
</script>

<style>
ol, ul {
  list-style: none;
  padding: 0px;
}
blockquote, q {
  quotes: none;
}
blockquote:before, blockquote:after,
q:before, q:after {
  content: '';
  content: none;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
.cd-schedule {
  position: relative;
  margin: 2em 0;
}

.cd-schedule::before {
  /* never visible - this is used in js to check the current MQ */
  content: 'mobile';
  display: none;
}

@media only screen and (min-width: 800px) {
  .cd-schedule {
    /* width: 90%; */
    max-width: 1400px;
    /* margin: 2em auto; */
  }
  .cd-schedule::after {
    clear: both;
    content: "";
    display: block;
  }
  .cd-schedule::before {
    content: 'desktop';
  }
}

.cd-schedule .timeline {
  display: none;
}

@media only screen and (min-width: 800px) {
  .cd-schedule .timeline {
    display: block;
    /* position: absolute; */
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    padding-top: 50px;
  }
  .cd-schedule .timeline li {
    position: relative;
    height: 50px;
  }
  .cd-schedule .timeline li::after {
    /* this is used to create the table horizontal lines */
    content: '';
    /* position: absolute; */
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background: #EAEAEA;
  }
  .cd-schedule .timeline li:last-of-type::after {
    display: none;
  }
  .cd-schedule .timeline li span {
    display: none;
  }
}

@media only screen and (min-width: 1000px) {
  .cd-schedule .timeline li::after {
    width: calc(100% - 60px);
    left: 60px;
  }
  .cd-schedule .timeline li span {
    display: inline-block;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }
  .cd-schedule .timeline li:nth-of-type(2n) span {
    display: none;
  }
}

.cd-schedule .events {
  position: relative;
  z-index: 1;
}

.cd-schedule .events .events-group {
  margin-bottom: 30px;
}

.cd-schedule .events .top-info {
  width: 100%;
  padding: 0 5%;
}

.cd-schedule .events .top-info > span {
  display: inline-block;
  line-height: 1.2;
  margin-bottom: 10px;
  font-weight: bold;
}

.cd-schedule .events .events-group > ul {
  position: relative;
  padding: 0 5%;
  /* force its children to stay on one line */
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
}

.cd-schedule .events .events-group > ul::after {
  /* never visible - used to add a right padding to .events-group > ul */
  display: inline-block;
  content: '-';
  width: 1px;
  height: 100%;
  opacity: 0;
  color: transparent;
}

.cd-schedule .events .single-event {
  /* force them to stay on one line */
  -ms-flex-negative: 0;
  flex-shrink: 0;
  float: left;
  height: 150px;
  width: 70%;
  max-width: 300px;
  box-shadow: inset 0 -3px 0 rgba(0, 0, 0, 0.2);
  margin-right: 20px;
  -webkit-transition: opacity .2s, background .2s;
  transition: opacity .2s, background .2s;
  background-color: #007cb5;
}

.cd-schedule .events .single-event:last-of-type {
  margin-right: 5%;
}

.cd-schedule .events .single-event a {
  display: block;
  height: 100%;
  padding: .8em;
  color: #ffffff;
}

@media only screen and (min-width: 550px) {
  .cd-schedule .events .single-event {
    width: 40%;
  }
}

@media only screen and (min-width: 800px) {
  .cd-schedule .events {
    float: left;
    width: 100%;
  }
  .cd-schedule .events .events-group {
    /* width: 20%; */
    float: left;
    border: 1px solid #EAEAEA;
    /* reset style */
    margin-bottom: 0;
  }
  .cd-schedule .events .events-group:not(:first-of-type) {
    border-left-width: 0;
  }
  .cd-schedule .events .top-info {
    /* vertically center its content */
    display: table;
    height: 50px;
    border-bottom: 1px solid #EAEAEA;
    /* reset style */
    padding: 0;
  }
  .cd-schedule .events .top-info > span {
    /* vertically center inside its parent */
    display: table-cell;
    vertical-align: middle;
    padding: 0 .5em;
    text-align: center;
    /* reset style */
    font-weight: normal;
    margin-bottom: 0;
  }
  .cd-schedule .events .events-group > ul {
    /* height: 950px; */
    /* reset style */
    display: block;
    overflow: visible;
    padding: 0;
  }
  .cd-schedule .events .events-group > ul::after {
    clear: both;
    content: "";
    display: block;
  }
  .cd-schedule .events .events-group > ul::after {
    /* reset style */
    display: none;
  }
  .cd-schedule .events .single-event {
    /* position: absolute; */
    z-index: 3;
    /* top position and height will be set using js */
    width: calc(100% + 2px);
    left: -1px;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1), inset 0 -3px 0 rgba(0, 0, 0, 0.2);
    /* reset style */
    -ms-flex-negative: 1;
    flex-shrink: 1;
    height: auto;
    max-width: none;
    margin-right: 0;
  }
  .cd-schedule .events .single-event a {
    padding: 1.2em;
  }
  .cd-schedule .events .single-event:last-of-type {
    /* reset style */
    margin-right: 0;
  }
  .cd-schedule .events .single-event.selected-event {
    /* the .selected-event class is added when an user select the event */
    visibility: hidden;
  }
}

@media only screen and (min-width: 1000px) {
  .cd-schedule .events {
    /* 60px is the .timeline element width */
    width: calc(100% - 80px);
    margin-left: 80px;
  }
}

.cd-schedule.loading .events .single-event {
  /* the class .loading is added by default to the .cd-schedule element
     it is removed as soon as the single events are placed in the schedule plan (using javascript) */
  opacity: 0;
}

.cd-schedule .event-name,
.cd-schedule .event-date {
  display: block;
  color: white;
  font-weight: bold;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.cd-schedule .event-name {
  font-size: 2.4rem;
}

@media only screen and (min-width: 800px) {
  .cd-schedule .event-name {
    font-size: 2rem;
  }
}

.cd-schedule .event-date {
  /* they are not included in the the HTML but added using JavScript */
  font-size: 1.4rem;
  opacity: .7;
  line-height: 1.2;
  margin-bottom: .2em;
}

.cd-schedule .single-event[data-event="event-1"],
.cd-schedule [data-event="event-1"] .header-bg {
  /* this is used to set a background color for the event and the modal window */
  background: #577F92;
}

.cd-schedule .single-event[data-event="event-1"]:hover {
  background: #618da1;
}

.cd-schedule .single-event[data-event="event-2"],
.cd-schedule [data-event="event-2"] .header-bg {
  background: #443453;
}

.cd-schedule .single-event[data-event="event-2"]:hover {
  background: #513e63;
}

.cd-schedule .single-event[data-event="event-3"],
.cd-schedule [data-event="event-3"] .header-bg {
  background: #A2B9B2;
}

.cd-schedule .single-event[data-event="event-3"]:hover {
  background: #b1c4be;
}

.cd-schedule .single-event[data-event="event-4"],
.cd-schedule [data-event="event-4"] .header-bg {
  background: #f6b067;
}

.cd-schedule .single-event[data-event="event-4"]:hover {
  background: #f7bd7f;
}

.cd-schedule .event-modal {
  position: fixed;
  z-index: 3;
  top: 0;
  right: 0;
  height: 100%;
  width: 100%;
  visibility: hidden;
  /* Force Hardware acceleration */
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-transform: translateX(100%);
  -ms-transform: translateX(100%);
  transform: translateX(100%);
  -webkit-transition: visibility .4s, -webkit-transform .4s;
  transition: visibility .4s, -webkit-transform .4s;
  transition: transform .4s, visibility .4s;
  transition: transform .4s, visibility .4s, -webkit-transform .4s;
  -webkit-transition-timing-function: cubic-bezier(0.5, 0, 0.1, 1);
  transition-timing-function: cubic-bezier(0.5, 0, 0.1, 1);
}

.cd-schedule .event-modal .header {
  position: relative;
  height: 70px;
  /* vertically center its content */
  display: table;
  width: 100%;
}

.cd-schedule .event-modal .header .content {
  position: relative;
  z-index: 3;
  /* vertically center inside its parent */
  display: table-cell;
  vertical-align: middle;
  padding: .6em 5%;
}

.cd-schedule .event-modal .body {
  position: relative;
  width: 100%;
  /* 70px is the .header height */
  height: calc(100% - 70px);
}

.cd-schedule .event-modal .event-info {
  position: relative;
  z-index: 2;
  line-height: 1.4;
  height: 100%;
  overflow: hidden;
}

.cd-schedule .event-modal .event-info > div {
  overflow: auto;
  height: 100%;
  padding: 1.4em 5%;
}

.cd-schedule .event-modal .header-bg, .cd-schedule .event-modal .body-bg {
  /* these are the morphing backgrounds - visible on desktop only */
  /* position: absolute; */
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}

.cd-schedule .event-modal .body-bg {
  z-index: 1;
  background: white;
  -webkit-transform-origin: top left;
  -ms-transform-origin: top left;
  transform-origin: top left;
}

.cd-schedule .event-modal .header-bg {
  z-index: 2;
  -webkit-transform-origin: top center;
  -ms-transform-origin: top center;
  transform-origin: top center;
}

.cd-schedule .event-modal .close {
  /* this is the 'X' icon */
  /* position: absolute; */
  top: 0;
  right: 0;
  z-index: 3;
  background: rgba(0, 0, 0, 0.1);
  /* replace text with icon */
  color: transparent;
  white-space: nowrap;
  text-indent: 100%;
  height: 70px;
  width: 70px;
}

.cd-schedule .event-modal .close::before, .cd-schedule .event-modal .close::after {
  /* these are the two lines of the 'X' icon */
  content: '';
  /* position: absolute; */
  top: 50%;
  left: 50%;
  width: 2px;
  height: 22px;
  background: white;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.cd-schedule .event-modal .close::before {
  -webkit-transform: translateX(-50%) translateY(-50%) rotate(45deg);
  -ms-transform: translateX(-50%) translateY(-50%) rotate(45deg);
  transform: translateX(-50%) translateY(-50%) rotate(45deg);
}

.cd-schedule .event-modal .close::after {
  -webkit-transform: translateX(-50%) translateY(-50%) rotate(-45deg);
  -ms-transform: translateX(-50%) translateY(-50%) rotate(-45deg);
  transform: translateX(-50%) translateY(-50%) rotate(-45deg);
}

.cd-schedule .event-modal .event-date {
  display: none;
}

.cd-schedule .event-modal.no-transition {
  -webkit-transition: none;
  transition: none;
}

.cd-schedule .event-modal.no-transition .header-bg, .cd-schedule .event-modal.no-transition .body-bg {
  -webkit-transition: none;
  transition: none;
}

@media only screen and (min-width: 800px) {
  .cd-schedule .event-modal {
    /* reset style */
    right: auto;
    width: auto;
    height: auto;
    -webkit-transform: translateX(0);
    -ms-transform: translateX(0);
    transform: translateX(0);
    will-change: transform, width, height;
    -webkit-transition: height .4s, width .4s, visibility .4s, -webkit-transform .4s;
    transition: height .4s, width .4s, visibility .4s, -webkit-transform .4s;
    transition: height .4s, width .4s, transform .4s, visibility .4s;
    transition: height .4s, width .4s, transform .4s, visibility .4s, -webkit-transform .4s;
    -webkit-transition-timing-function: cubic-bezier(0.5, 0, 0.1, 1);
    transition-timing-function: cubic-bezier(0.5, 0, 0.1, 1);
  }
  .cd-schedule .event-modal .header {
    /* position: absolute; */
    display: block;
    top: 0;
    left: 0;
    height: 100%;
  }
  .cd-schedule .event-modal .header .content {
    /* reset style */
    display: block;
    padding: .8em;
  }
  .cd-schedule .event-modal .event-info > div {
    padding: 2em 3em 2em 2em;
  }
  .cd-schedule .event-modal .body {
    height: 100%;
    width: auto;
  }
  .cd-schedule .event-modal .header-bg, .cd-schedule .event-modal .body-bg {
    /* Force Hardware acceleration */
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    will-change: transform;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
  }
  .cd-schedule .event-modal .header-bg {
    -webkit-transition: -webkit-transform .4s;
    transition: -webkit-transform .4s;
    transition: transform .4s;
    transition: transform .4s, -webkit-transform .4s;
    -webkit-transition-timing-function: cubic-bezier(0.5, 0, 0.1, 1);
    transition-timing-function: cubic-bezier(0.5, 0, 0.1, 1);
  }
  .cd-schedule .event-modal .body-bg {
    opacity: 0;
    -webkit-transform: none;
    -ms-transform: none;
    transform: none;
  }
  .cd-schedule .event-modal .event-date {
    display: block;
  }
  .cd-schedule .event-modal .close, .cd-schedule .event-modal .event-info {
    opacity: 0;
  }
  .cd-schedule .event-modal .close {
    width: 40px;
    height: 40px;
    background: transparent;
  }
  .cd-schedule .event-modal .close::after, .cd-schedule .event-modal .close::before {
    background: #222222;
    height: 16px;
  }
}

@media only screen and (min-width: 1000px) {
  .cd-schedule .event-modal .header .content {
    padding: 1.2em;
  }
}

.cd-schedule.modal-is-open .event-modal {
  /* .modal-is-open class is added as soon as an event is selected */
  -webkit-transform: translateX(0);
  -ms-transform: translateX(0);
  transform: translateX(0);
  visibility: visible;
}

.cd-schedule.modal-is-open .event-modal .event-info > div {
  /* smooth scroll on iOS touch devices */
  -webkit-overflow-scrolling: touch;
}

@media only screen and (min-width: 800px) {
  .cd-schedule.animation-completed .event-modal .close,
  .cd-schedule.content-loaded.animation-completed .event-modal .event-info {
    /* 	the .animation-completed class is added when the modal animation is completed
      the .content-loaded class is added when the modal content has been loaded (using ajax) */
    opacity: 1;
    -webkit-transition: opacity .2s;
    transition: opacity .2s;
  }
  .cd-schedule.modal-is-open .body-bg {
    opacity: 1;
    -webkit-transition: -webkit-transform .4s;
    transition: -webkit-transform .4s;
    transition: transform .4s;
    transition: transform .4s, -webkit-transform .4s;
    -webkit-transition-timing-function: cubic-bezier(0.5, 0, 0.1, 1);
    transition-timing-function: cubic-bezier(0.5, 0, 0.1, 1);
  }
}

.cd-schedule .cover-layer {
  /* layer between the content and the modal window */
  position: fixed;
  z-index: 2;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.8);
  opacity: 0;
  visibility: hidden;
  -webkit-transition: opacity .4s, visibility .4s;
  transition: opacity .4s, visibility .4s;
}

.cd-schedule.modal-is-open .cover-layer {
  opacity: 1;
  visibility: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/schedule/TlSchedule.vue